import React from 'react';
import AppModel from 'src/model';
import { device } from 'src/helpers';
import { Logo, MCButton, MCText } from 'src/components/basic';
import LANG_CONST from 'src/helpers/lang/const';
import SVGIcon, { GENERAL_ICONS } from 'src/components/svg';
import Model from 'src/storage/base';

// The popup never puts the session id (sid) in the app link. It asks the server for a
// short-lived, single-use code instead; the app exchanges that code for its own session.
class MobileAppsModel extends Model {
  id = 'MobileAppsModel';
  persistent = false;

  apiConfig = {
    handoff: {
      url: 'auth/handoff',
      validation: { action: 'string' }
    }
  };

  getHandoffCode = (params, cb) => {
    this.api('handoff', params, (err, data, success) => {
      if (success && data?.ok && data.code) cb(null, data.code);
      else cb(err || new Error('handoff failed'));
    });
  };
}
const model = new MobileAppsModel();

export default class MobileAppsPopup extends React.PureComponent {
  openAndroid = () => {
    let path = AppModel.getState().redirect || window.location.pathname;
    if (path[0] === '/') path = path.substring(1);
    let appUrl = 'lifeapp://' + path;
    // let storeUrl = 'https://play.google.com/store/apps/details?id=ai.lifeapp';
    let storeUrl = 'market://details?id=ai.lifeapp';

    setTimeout(() => {
      window.location.replace(storeUrl);
    }, 1000);
    // alert(appUrl);
    window.location.replace(appUrl);
  };

  openIos = () => {
    let path = AppModel.getState().redirect || window.location.pathname;
    if (path[0] === '/') path = path.substring(1);
    let appUrl = 'lifeapp://' + path;
    let storeUrl = 'https://apps.apple.com/us/app/lifeapp/id1551683501';
    setTimeout(() => {
      window.location.replace(storeUrl);
    }, 1000);
    window.location.replace(appUrl);
  };

  openApp = (targetDevice) => {
    const { data } = this.props;
    if (data?.action === 'book' || data?.action === 'chat') {
      model.getHandoffCode({ action: data.action, contactId: data.contactId }, (err, code) => {
        // If we cannot get a code, still open the app (the user signs in there)
        const url = err
          ? 'redirect'
          : `signin_code?hcode=${encodeURIComponent(code)}&action=${data.action}&contactId=${data.contactId}`;
        this.launchApp(targetDevice, url);
      });
      return;
    }
    this.launchApp(targetDevice, 'redirect');
  };

  launchApp = (targetDevice, url) => {
    const fallbackToStore = function () {
      if ((!targetDevice && device === 'ios') || targetDevice === 'ios') {
        window.location = 'https://apps.apple.com/us/app/lifeapp/id1551683501';
      } else if (device === 'android') {
        window.location =
          'https://play.app.goo.gl/?link=https://play.google.com/store/apps/details?id=ai.lifeapp';
      }
    };
    window.location = `lifeapp://${url}`;
    setTimeout(fallbackToStore, 100);
  };

  render() {
    const { closeBtn } = this.props;
    return (
      <div className={'mc-popup-contain'}>
        {closeBtn}
        <div className={'mc-flex-25-col '}>
          <div className={'mc-flex-25-col mc-flex-center'} style={{ textAlign: 'center' }}>
            <MCText heading weight={500} size={24} label={LANG_CONST.install_app} />
            <Logo logoProps={{ width: 60, height: 60 }} />
            <MCText heading weight={400} size={18} label={LANG_CONST.text.install_app} />
          </div>
          <div className={'mc-flex-20'}>
            <MCButton flex tiny onClick={() => this.openApp('ios')}>
              <SVGIcon iconname={GENERAL_ICONS.APPLE_BLACK} />
            </MCButton>
            <MCButton flex tiny onClick={() => this.openApp('android')}>
              <SVGIcon iconname={GENERAL_ICONS.GOOGLE_BLACK} />
            </MCButton>
          </div>
        </div>
      </div>
    );
  }
}
